/*
====================================================================
                    Componente InptContraseña
====================================================================
Este componente define un campo de entrada para la contraseña con la 
funcionalidad de mostrar u ocultar el texto de la contraseña.

- Permite al usuario alternar la visibilidad de la contraseña.
- Utiliza un ícono interactivo para cambiar entre el tipo 'password' y 'text'.
- Recibe una referencia y una función para manejar el cambio en el input.

====================================================================
*/

// ------------------------------------------------------------------
//                            IMPORTS
// ------------------------------------------------------------------
// Importación de librerías estándar de React.

import React, { useState } from "react";

// ------------------------------------------------------------------
//                       DEFINICIÓN DEL COMPONENTE
// ------------------------------------------------------------------
/**
 * Componente de entrada para contraseñas.
 *
 * Este componente proporciona un input para la contraseña, con la
 * funcionalidad de mostrar u ocultar el contenido del input mediante un
 * ícono de visibilidad.
 *
 * @param {object} props
 * @param {React.Ref} props.contraseñaRef - Referencia para el input de contraseña.
 * @param {function} props.handleInpPass - Función para manejar el evento onChange del input.
 *
 * @returns {JSX.Element} El componente de entrada de contraseña.
 */
export default function InptContraseña({
  texto="Contraseña",
  contraseñaRef = null,
  handleInpPass = () => {},
  onKeyDown = () => {},
}) {
  const [mostrarContraseña, setMostrarContraseña] = useState(false);

  /**
   * Alterna la visibilidad de la contraseña.
   *
   * Cambia el estado de `mostrarContraseña`, lo que a su vez cambia el tipo de input
   * entre 'text' y 'password'.
   */
  const alternarVisibilidadContraseña = () => {
    setMostrarContraseña(!mostrarContraseña);
  };

  return (
    <div data-figma-id="3013:6762" className="correo-8">
      <p data-figma-id="3013:6757" className="contrasa-titulo">
        {texto}
      </p>
      <div data-figma-id="3013:6756" className="contrasea-info">
        <input
        id="modal_publico"
          ref={contraseñaRef}
          onChange={handleInpPass}
          type={mostrarContraseña ? "text" : "password"} // Cambia el tipo de input entre 'text' y 'password'
          data-figma-id="3013:6758"
          className="correo-ejemplo-3"
          placeholder="Contraseña"
          onKeyDown={onKeyDown}
        />
        <i
          className={`fi ${
            mostrarContraseña ? "fi-rr-eye" : "fi-rr-eye-crossed"
          } crossed-eye-1`}
          onClick={alternarVisibilidadContraseña}
        ></i>
      </div>
    </div>
  );
}

// ------------------------------------------------------------------
//                            EXPORTS
// ------------------------------------------------------------------
// Exportación del componente para su uso en otros módulos de la aplicación.
